import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { getKeywordSearch } from '../api/product';

export default function Page() {
  const [keyword, setKeyword] = useState<string>('');
  const [keyItems, setKeyItems] = useState<any>([]);
  const onChangeData = (e: React.FormEvent<HTMLInputElement>) => {
    setKeyword(e.currentTarget.value);
  };

  const fetchData = () => {
    return getKeywordSearch('POPULAR', 1, keyword)
      .then((res) => {
        setKeyItems(res.data.items);
      })
      .catch((err) => console.log(err));
  };

  const updateData = async () => {
    fetchData();
    const res = keyItems;
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (keyword) updateData();
    }, 100);
    if (keyword.length === 0) {
      setKeyItems([]);
    }
    return () => {
      clearTimeout(debounce);
    };
  }, [keyword]); //키워드가 변경되면 api를 호출

  return (
    <>
      <SearchContainer>
        <Search value={keyword} onChange={onChangeData} />
        {/* keyword 변수와 이벤트 조작 */}
        <img src="assets/imgs/search.svg" alt="searchIcon" />
        {
          <AutoSearchContainer>
            <AutoSearchWrap>
              {keyItems.map((el: any, idx: any) => {
                return (
                  <AutoSearchData key={idx}>
                    <Link to="#">{el?.productName}</Link>
                    <img src="assets/imgs/north_west.svg" alt="arrowIcon" />
                  </AutoSearchData>
                );
              })}
            </AutoSearchWrap>
          </AutoSearchContainer>
        }
      </SearchContainer>
    </>
  );
}

const SearchContainer = styled.div`
  width: 400px;
  height: 45px;
  position: relative;
  border: 0;
  img {
    position: absolute;
    right: 10px;
    top: 10px;
  }
`;

const Search = styled.input`
  border: 0;
  padding-left: 10px;
  background-color: var(--colGray3);
  width: 100%;
  height: 100%;
  outline: none;
`;

const AutoSearchContainer = styled.div`
  z-index: 3;
  height: 50vh;
  width: 400px;
  background-color: var(--colWhite);
  position: absolute;
  top: 45px;
  border: 2px solid;
  padding: 15px;
`;

const AutoSearchWrap = styled.ul``;

const AutoSearchData = styled.li`
  padding: 10px 8px;
  width: 100%;
  font-size: 14px;
  font-weight: bold;
  z-index: 4;
  letter-spacing: 2px;
  &:hover {
    background-color: #edf5f5;
    cursor: pointer;
  }
  position: relative;
  img {
    position: absolute;
    right: 5px;
    width: 18px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
